import { Link } from "react-router-dom";
import { ContactEmails } from "components/common/ContactEmails";
import { Logo } from "components/logo";

const footerLinks = {
  company: [
    { label: "About", href: "/about", className: "d-none" },
    { label: "Careers", href: "#", className: "d-none" },
    { label: "Press", href: "#", className: "d-none" },
    { label: "Contact", href: "/contact" },
  ],
  investors: [
    { label: "How It Works", href: "/how-it-works" },
    { label: "Browse Opportunities", href: "/opportunities", className: "d-none" },
    { label: "Investment Risks", href: "/risks" },
    { label: "FAQ", href: "/faq" },
  ],
  companies: [
    { label: "Raise Capital", href: "/raise" },
    { label: "Eligibility", href: "/eligibility", className: "d-none" },
    { label: "Success Stories", href: "#", className: "d-none" },
    { label: "Resources", href: "#", className: "d-none" },
  ],
  legal: [
    { label: "Terms of Use", href: "/terms" },
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Disclosures", href: "/disclosures" },
    { label: "Refund Policy", href: "/refund-policy" },
    { label: "Risk Disclosure", href: "/risk-disclosure", className: "d-none" },
    { label: "Investor Overview", href: "/investor-overview" },
  ],
};

export function Footer() {
  return (
    <footer className="border-t bg-card">
      <div className="container mx-auto px-4 py-12 sm:px-6 lg:px-12 xl:px-16">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-6 md:items-start">
          <div className="col-span-2 md:col-span-2">
            <Logo />
            <p className="mt-4 text-xs text-muted-foreground">
              Fortify Portal, Inc. is not registered under securities legislation in any
              jurisdiction of Canada. Fortify is relying on the exemption from the dealer
              registration requirement under National Instrument 45-110 Start-up Crowdfunding
              Registration and Prospectus Exemptions. Fortify does not provide advice about
              the suitability or merits of any investment. Investing in start-up and
              early-stage businesses involves significant risk, including the possible loss
              of your entire investment. Past performance is not indicative of future
              results.
            </p>
            <ContactEmails className="mt-4 text-xs" linkClassName="text-xs" />
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label} className={link.className}>
                  <Link
                    to={link.href}
                    className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold">For Investors</h4>
            <ul className="space-y-3">
              {footerLinks.investors.map((link) => (
                <li key={link.label} className={link.className}>
                  <Link
                    to={link.href}
                    className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold">For Companies</h4>
            <ul className="space-y-3">
              {footerLinks.companies.map((link) => (
                <li key={link.label} className={link.className}>
                  <Link
                    to={link.href}
                    className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold">Legal</h4>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.label} className={link.className}>
                  <Link
                    to={link.href}
                    className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t pt-8 md:flex-row">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Fortify. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="#" className="text-muted-foreground transition-colors hover:text-foreground">
              <span className="sr-only">Twitter</span>
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
            </Link>
            <Link to="#" className="text-muted-foreground transition-colors hover:text-foreground">
              <span className="sr-only">LinkedIn</span>
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
